module.exports = __webpack_public_path__ + "static/grafia-5a4ae4da1ca38466c3603ebb9ecc64ef.svg";